<template>
<div class="row">
  <div class="col-md-10 col-md-offset-1">

    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Especificalções do evento: {{eventSpecifications.event.reference}}</h4>
      </div>
      <div class="card-content">
        <h4>Categorias</h4>
        <div
          class="form-group"
          v-for="(categorie) in categories"
          :key="categorie._id"
        >
          <label>{{categorie.name}}</label>
          <p
            class="radio-input"
            v-for="tag in tagsByCategories[categorie._id]"
            :key="tag._id"
          >
            <input
              :checked="checkedTag(categorie._id, tag._id)"
              @change="handlInputTag"
              type="radio"
              :value="tag._id"
              :name="categorie._id"
            > {{tag.name}}
          </p>
        </div>

        <h4>Icone no mapa</h4>
        <InputRadioIconRefrigeratoMap v-model="eventSpecifications.refrigeratorIcon"/>

        <h4>GPS</h4>
        <EventLocalMap
          :specGps="eventSpecifications.gps"
          @changeGps="(event) => Object.assign(eventSpecifications.gps, {lat: event.lat, lng: event.lng})"
        />
        <div class="form-group">
          <label>Latidude</label>
          <input
            readonly
            type="number"
            name="latitude"
            class="form-control"
            v-model="eventSpecifications.gps.lat"
          >
          <small>Defina LATITUDE utilizando o mapa.</small>
        </div>
        <div class="form-group">
          <label>Longitude</label>
          <input
            readonly
            class="form-control"
            type="number"
            name="latitude"
            v-model="eventSpecifications.gps.lng"
          >
          <small>Defina LONGITUDE utilizando o mapa.</small>
        </div>
      </div>
    </div>

    <div
      class='text-right'
      style="margin-bottom: 30px;"
    >
      <button
        type="submit"
        @click.prevent="handleSave"
        class="btn btn-fill btn-success btn-wd"
      ><i class="ti-save"></i> Salvar
      </button>
    </div>
  </div>
</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import EventLocalMap from '../../components/Trg/EventsSpecifications/EventLocalMap'
import InputRadioIconRefrigeratoMap from '../../components/Trg/EventsSpecifications/InputRadioIconRefrigeratoMap'

export default {
  name: 'FormEventsSpecifications',
  components: {
    EventLocalMap,
    InputRadioIconRefrigeratoMap
  },
  computed: {
    ...mapGetters('eventsSpecifications', ['eventSpecifications']),
    ...mapGetters('categories', ['categories']),
    ...mapGetters('tags', ['tagsByCategories'])
  },
  methods: {
    ...mapActions('tags', {fetchTags: 'fetchAll'}),
    ...mapActions('categories', {fetchCategories: 'fetchAll'}),
    ...mapActions('eventsSpecifications', ['fetchOne', 'setTags', 'upsert']),
    handleSave () {
      this.upsert(Object.assign(this.eventSpecifications, {tagsIds: Object.values(this.eventSpecifications.tags)}))
        .then(() => {
          this.$router.push({name: 'eventsSpecifications.index'})
        })
    },
    handlInputTag (event) {
      this.setTags({categorie: event.target.name, tag: event.target._value})
    },
    checkedTag (categorie, tag) {
      return this.eventSpecifications.tags.hasOwnProperty(categorie) && this.eventSpecifications.tags[categorie] === tag
    }
  },
  mounted () {
    this.fetchTags({limit: 999})
    this.fetchCategories({limit: 9999})
    this.fetchOne(this.$route.params.id)
  }
}
</script>

<style scoped>
  .radio-input {
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/EventsSpecifications/FormEventsSpecifications.vue